"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

var _cust = _interopRequireWildcard(require("@/api/cust"));

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "index",
  components: {
    UserSelect: _multiUserSelect.default
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    permission: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showUserSelect: false
    };
  },
  methods: {
    onCustToFollowUser: function onCustToFollowUser() {
      var _this = this;

      this.username = this.user.username;
      this.$confirm('此操作将从之前所属部门的客户同步到当前所属部门', '是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var changeInfo = {
          userName: _this.username
        };

        _cust.default.custToFollowUser(changeInfo).then(function (res) {
          _this.$notify({
            title: '同步成功',
            type: 'success',
            duration: 1500
          });
        }).catch(function (err) {
          console.log(err.response.data.message);
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消同步'
        });
      });
    },
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
    },
    selectUserCallBack: function selectUserCallBack(user) {
      console.log(user);
    }
  }
};
exports.default = _default;